import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import paymentSuccessfullImage from "../../assets/payment-check.png";
import paymentFailedImg from "../../assets/payment-failed.png";
import { useTranslation } from "../../context/TranslationContext";
import 'bootstrap-icons/font/bootstrap-icons.css';

const PaymentSuccess = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { translateSync } = useTranslation();

    const tranRef = searchParams.get('tranRef') || searchParams.get('tran_ref');
    const respStatus = searchParams.get('respStatus') || searchParams.get('response_status')
    const cartId = searchParams.get('cartId') || searchParams.get('cart_id');
    const message = searchParams.get('message');

    // Handle PayTabs status codes: 'A' or 'success'
    const isSuccess = (respStatus === 'A' || respStatus === 'success') && !window.location.pathname.includes('failed');

    return (
        <section className="py-5" style={{
            minHeight: 'calc(100vh - 100px)',
            display: 'flex',
            alignItems: 'center',
            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
            position: 'relative',
            overflow: 'hidden',
            marginTop: '100px'
        }}>
            {/* Animated Background Blobs */}
            <div style={{
                position: 'absolute',
                top: '10%',
                left: '5%',
                width: '300px',
                height: '300px',
                background: isSuccess ? 'rgba(40, 167, 69, 0.1)' : 'rgba(220, 53, 69, 0.1)',
                filter: 'blur(80px)',
                borderRadius: '50%',
                zIndex: 0
            }} />
            <div style={{
                position: 'absolute',
                bottom: '10%',
                right: '5%',
                width: '400px',
                height: '400px',
                background: isSuccess ? 'rgba(0, 123, 255, 0.08)' : 'rgba(255, 193, 7, 0.08)',
                filter: 'blur(100px)',
                borderRadius: '50%',
                zIndex: 0
            }} />

            <div className="container position-relative" style={{ zIndex: 1 }}>
                <div className="row justify-content-center">
                    <div className="col-lg-5 col-md-8">
                        <div className="card border-0 shadow-lg overflow-hidden animate__animated animate__fadeIn"
                            style={{
                                borderRadius: '32px',
                                background: 'rgba(255, 255, 255, 0.95)',
                                backdropFilter: 'blur(20px)',
                                border: '1px solid rgba(255, 255, 255, 0.3)'
                            }}>

                            {/* Top Status Banner */}
                            <div className={`py-3 ${isSuccess ? 'bg-success' : 'bg-danger'}`} style={{ opacity: 0.9 }}>
                                <div className="text-center text-white">
                                    <i className={`bi ${isSuccess ? 'bi-check-circle-fill' : 'bi-x-circle-fill'} fs-1`}></i>
                                </div>
                            </div>

                            <div className="card-body p-5 text-center">
                                <div className="mb-3">
                                    <h3 className="fw-bold mb-1" style={{ color: '#2d3748', letterSpacing: '-0.5px' }}>
                                        {isSuccess ? translateSync('Everything is Set!') : translateSync('Oh, Something Went Wrong')}
                                    </h3>
                                    <div className={`mx-auto mb-3`} style={{ width: '35px', height: '3px', background: isSuccess ? '#28a745' : '#dc3545', borderRadius: '2px' }}></div>
                                </div>

                                <p className="text-muted mb-4 small px-lg-4" style={{ lineHeight: '1.5' }}>
                                    {isSuccess
                                        ? translateSync('Great news! Your payment was successful and your order is now being processed. We will notify you once it ships.')
                                        : translateSync(message || 'Your payment could not be processed at this time. Don\'t worry, your cart items are still saved.')
                                    }
                                </p>

                                {/* Modern Details Box */}
                                <div className="p-3 rounded-4 mb-4" style={{
                                    backgroundColor: '#ffffff',
                                    border: '1px solid #edf2f7',
                                    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.02)'
                                }}>
                                    <table className="table table-borderless table-sm mb-0">
                                        <tbody>
                                            <tr>
                                                <td className="text-start text-secondary x-small py-1" style={{ fontSize: '11px' }}>{translateSync('REFERENCE')}</td>
                                                <td className="text-end fw-bold x-small py-1 text-dark text-break" style={{ fontSize: '11px' }}>{tranRef || 'N/A'}</td>
                                            </tr>
                                            {cartId && (
                                                <tr>
                                                    <td className="text-start text-secondary x-small py-1" style={{ fontSize: '11px' }}>{translateSync('ORDER ID')}</td>
                                                    <td className="text-end fw-bold x-small py-1 text-dark" style={{ fontSize: '11px' }}>{cartId}</td>
                                                </tr>
                                            )}
                                            {respStatus && !isSuccess && (
                                                <tr>
                                                    <td className="text-start text-secondary x-small py-1" style={{ fontSize: '11px' }}>{translateSync('RESPONSE CODE')}</td>
                                                    <td className="text-end fw-bold x-small py-1 text-danger" style={{ fontSize: '11px' }}>{respStatus}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Premium Action Buttons */}
                                <div className="d-grid gap-2">
                                    {isSuccess ? (
                                        <>
                                            <button
                                                className="btn btn-dark py-3 shadow-sm rounded-3 d-flex align-items-center justify-content-center gap-2"
                                                style={{ transition: 'all 0.3s', fontWeight: '600', backgroundColor: '#1a202c' }}
                                                onClick={() => navigate('/pageaccount?tab=orders')}
                                            >
                                                <i className="bi bi-box-seam"></i> {translateSync('Manage Your Orders')}
                                            </button>
                                            <button
                                                className="btn btn-outline-secondary border-2 py-3 rounded-3 d-flex align-items-center justify-content-center gap-2"
                                                style={{ transition: 'all 0.3s', fontWeight: '500' }}
                                                onClick={() => navigate('/')}
                                            >
                                                {translateSync('Continue Shopping')} <i className="bi bi-arrow-right"></i>
                                            </button>
                                        </>
                                    ) : (
                                        <>
                                            <button
                                                className="btn btn-danger py-2 shadow-sm rounded-3 d-flex align-items-center justify-content-center gap-2"
                                                style={{ transition: 'all 0.3s', fontWeight: '600' }}
                                                onClick={() => navigate('/checkout')}
                                            >
                                                <i className="bi bi-arrow-repeat"></i> {translateSync('Try Again')}
                                            </button>
                                            <button
                                                className="btn btn-outline-dark border-2 py-2 rounded-3 d-flex align-items-center justify-content-center gap-2"
                                                style={{ transition: 'all 0.3s', fontWeight: '500' }}
                                                onClick={() => navigate('/contact')}
                                            >
                                                <i className="bi bi-headset"></i> {translateSync('Contact Support')}
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Minimal Footer */}
                        <div className="mt-5 text-center" style={{ opacity: 0.7 }}>
                            <p className="small text-secondary">
                                {translateSync('A confirmation email will be sent to your registered address.')}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <style>{`
                .animate__animated {
                    animation-duration: 0.8s;
                    animation-fill-mode: both;
                }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .animate__fadeIn {
                    animation-name: fadeIn;
                }
                .btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 15px rgba(0,0,0,0.1) !important;
                }
                .btn:active {
                    transform: translateY(0);
                }
            `}</style>
        </section>
    );
};

export default PaymentSuccess;

